<template>
    <div class="user_mm no-trans" v-loading="loading">
        <div class="page_name">修改密码</div>
        <div class="info_box">
            <div class="form_flex">
                <div class="form_title">
                    <!-- <span>*</span> -->
                    旧密码：
                </div>
                <div class="input2">
                    <el-input v-model="forms.password" placeholder="请输入旧密码"></el-input>
                </div>
            </div>
            <div class="form_flex">
                <div class="form_title">
                    <!-- <span>*</span> -->
                    新密码：
                </div>
                <div class="input2">
                    <el-input v-model="forms.new_password" placeholder="请输入新密码"></el-input>
                </div>
            </div>
            <div class="form_flex">
                <div class="form_title">
                    <!-- <span>*</span> -->
                    重复新密码：
                </div>
                <div class="input2">
                    <el-input v-model="forms.new_password2" placeholder="请重复输入新密码"></el-input>
                </div>
            </div>
     
            <div class="form_flex">
                <div class="form_title">
                </div>
                <div class="btn_flex">
                    <div class="btns1" @click="handle_end">确定</div>
                    <div class="btns2" @click="handle_clear">取消</div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
import { mapState} from 'vuex'
 


export default {
    components: {
        
    },
    name: "homes",
    data() {
        return {
            loading: false,
            forms:{
                password:'',
                new_password:'',
                new_password2:'',
            }
           
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {

    },
    methods: {
        handle_clear(){
            this.forms={
                password:'',
                new_password:'',
                new_password2:'',
            }
            
        },
        handle_end(){
            if(!this.forms.password){
                alertErr('请输入旧密码')
                return
            }
            if(!this.forms.new_password){
                alertErr('请输入新密码')
                return
            }
            if(this.forms.password==this.forms.new_password){
                alertErr('新密码不能与旧密码一致')
                return
            }
            if(!this.forms.new_password2){
                alertErr('请输入重复密码')
                return
            }
            if(this.forms.new_password!=this.forms.new_password2){
                alertErr('两次密码不一致')
                return
            }
            this.$api("update_password", {
                ...this.forms
			}, "post").then((res) => {
                this.loading = false
                console.log('修改密码',res)
                if (res.code == 1) {
                    alertSucc('密码修改成功，请重新登录')
                    localStorage.setItem('token','')
                    this.$store.dispatch("appInit"); //重新初始化
                    this.$store.dispatch("query_user"); //获取用户信息
                    this.$router.push({
                        path:'/login'
                    })
                } else {
                    alertErr(res.msg)
                }
            });
        },




    },

}
</script>
<style scoped lang="less">
.user_mm {  
    .page_name{
        width: 1196px;
        height: 56px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        padding: 0 32px;
        line-height: 56px;  
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        color: #333333;

    }
    .info_box{
        width: 1196px;
        min-height: 1013px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        margin-top: 18px;
        padding-top: 40px;

        .form_flex{
            display: flex;
            // align-items: center;
            padding-bottom: 24px;

            .form_title{
                width: 140px;
                height: 40px;
                line-height: 40px;
                text-align: right;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #999999;
                padding-right: 24px;
                flex-shrink: 0;
                span{
                    color: #FD4C5C; 
                }
            }
            .input2{
                display: flex;
                align-items: center;
                /deep/.el-select{
                    width: 400px;
                    height: 40px;
                }
                /deep/.el-input{
                    width: 400px;
                    height: 40px;
                }
                .input_text1{
                    padding-left: 15px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #888888;
    
                }

            }
           
             
          
            .btn_flex{
                display: flex;
                align-items: center;
                .btns1{
                    // width: 134px;
                    width: 76px;
                    height: 40px;
                    background: #377CFD;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #377CFD;
                    text-align: center;
                    line-height: 40px;
                    cursor: pointer;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 14px;
                    color: #FFFFFF;

                }
                .btns2{
                    // width: 134px;
                    width: 76px;
                    height: 40px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #377CFD;
                    text-align: center;
                    line-height: 40px;
                    cursor: pointer;
                    margin-left: 24px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 14px;
                    color: #377CFD;

                }
            }
        }
    }
}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .user_mm.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .user_mm.no-trans .page_name {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 56px;
        border-radius: 0px 0px 0px 0px;
        padding: 0 16px;
        line-height: 1.6;
        font-size: 16px;
    }
    .user_mm.no-trans .info_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        border-radius: 0px 0px 0px 0px;
        margin-top: 16px;
        padding-top: 16px;
    }
    .user_mm.no-trans .info_box .form_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-bottom: 16px;
        flex-direction: column;
        align-items: stretch;
    }
    .user_mm.no-trans .info_box .form_flex .form_title {
        width: 100%;
        height: 40px;
        line-height: 1.6;
        font-size: 14px;
        padding-right: 16px;
        text-align: left;
        padding: 0;
    }
    .user_mm.no-trans .info_box .form_flex .input2 {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        max-width: 100%;
    }
    .user_mm.no-trans .info_box .form_flex .input2 /deep/ .el-select {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 40px;
    }
    .user_mm.no-trans .info_box .form_flex .input2 /deep/ .el-input {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 40px;
    }
    .user_mm.no-trans .info_box .form_flex .input2 .input_text1 {
        padding-left: 15px;
        font-size: 14px;
    }
    .user_mm.no-trans .info_box .form_flex .btn_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_mm.no-trans .info_box .form_flex .btn_flex .btns1 {
        width: 76px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .user_mm.no-trans .info_box .form_flex .btn_flex .btns2 {
        width: 76px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        margin-left: 16px;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
}
</style>
